/** Shared layout classes for admin dashboard 2x2 chart cards (equal row height). */
export const DASHBOARD_CHART_GRID =
  'grid grid-cols-1 xl:grid-cols-2 auto-rows-fr items-stretch gap-3 mb-3 sm:gap-4 sm:mb-4';

export const DASHBOARD_CHART_CELL = 'h-full min-h-[340px] flex flex-col';

export const DASHBOARD_CHART_CARD = 'h-full w-full flex flex-col';

/** Use with Card padding="none" so padding is not doubled. */
export const DASHBOARD_CHART_CONTENT = 'p-3 sm:p-4 flex flex-col flex-1 min-h-0';

export const DASHBOARD_CHART_BODY = 'flex flex-col flex-1 min-h-0 justify-center';

export const DASHBOARD_CHART_HEADER =
  'flex flex-shrink-0 items-center justify-between gap-2.5';

export const DASHBOARD_CHART_HEADER_LEFT = 'flex min-w-0 items-center gap-2.5';

export const DASHBOARD_CHART_ICON_WRAP = 'flex-shrink-0 rounded-md p-1.5';

export const DASHBOARD_CHART_ICON = 'h-4 w-4';

export const DASHBOARD_CHART_TITLE =
  'text-sm sm:text-base font-semibold text-primary-500';

export const DASHBOARD_CHART_SUBTITLE = 'text-[11px] sm:text-xs text-primary-500/50';
